(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4281],{

/***/ 64049:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liquidity/browse",
      function () {
        return __webpack_require__(46899);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42761);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98396);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99226);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79332);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87109);
/* harmony import */ var _mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26447);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39838);







const Bar = (param)=>{
    let { inputValue , setInputValue , tabActive , ...props } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const redirectTab = (tab)=>{
        if (tab !== tabActive) {
            router.replace("/liquidity/".concat(tab === "pools" ? "browse" : "portfolio"));
        }
    };
    const isSmallScreen = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().breakpoints.down("sm"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        direction: isSmallScreen ? "column" : "row",
        className: "h-full",
        alignItems: isSmallScreen ? "normal" : "center",
        justifyContent: "space-between",
        spacing: isSmallScreen ? 2 : 1,
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                direction: "row",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        direction: "column",
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                "data-testid": "btn-nav-pools",
                                onClick: ()=>redirectTab("pools"),
                                fullWidth: true,
                                className: "py-3 px-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    sx: {
                                        color: tabActive === "pools" ? "#FFFFFF" : "#888C9E",
                                        fontWeight: 600
                                    },
                                    textTransform: "none",
                                    whiteSpace: "nowrap",
                                    children: trans.liquidity.bar.pools
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                sx: {
                                    height: 2
                                },
                                className: tabActive === "pools" ? "bg-gradient-btn" : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        direction: "column",
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                "data-testid": "btn-nav-portfolio",
                                onClick: ()=>redirectTab("portfolio"),
                                fullWidth: true,
                                className: "py-3 px-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    sx: {
                                        color: tabActive === "portfolio" ? "#FFFFFF" : "#888C9E",
                                        fontWeight: 600
                                    },
                                    textTransform: "none",
                                    whiteSpace: "nowrap",
                                    children: trans.liquidity.bar.positions
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                sx: {
                                    height: 2
                                },
                                className: tabActive === "portfolio" ? "bg-gradient-btn" : ""
                            })
                        ]
                    })
                ]
            }),
            tabActive === "pools" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                direction: isSmallScreen ? "column-reverse" : "row",
                alignItems: "flex-start",
                spacing: 2,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    "data-testid": "input-search-mint-address",
                    className: "border border-solid border-[#61667E] bg-[#2A3748] rounded-lg p-2 text-sm sm:w-56 md:w-80 lg:w-96",
                    disableUnderline: true,
                    placeholder: trans.liquidity.pool_search_placeholder,
                    startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        position: "start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
                    }),
                    inputProps: {
                        className: "p-0 pr-3 text-md"
                    },
                    onChange: (e)=>{
                        return setInputValue === null || setInputValue === void 0 ? void 0 : setInputValue(e.target.value);
                    },
                    value: inputValue,
                    style: isSmallScreen ? {
                        width: "100%"
                    } : undefined
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(Bar));


/***/ }),

/***/ 46899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ browse_nemo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js
var debounce = __webpack_require__(57144);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/use-nemo-apis.ts
var use_nemo_apis = __webpack_require__(67013);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./src/components/base/Bar.tsx
var Bar = __webpack_require__(10577);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 1 modules
var useTrans = __webpack_require__(39838);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(7906);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js
var TableCell = __webpack_require__(98102);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(68509);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@orca-so/common-sdk/dist/index.js
var dist = __webpack_require__(66259);
// EXTERNAL MODULE: ./node_modules/@solana/web3.js/lib/index.browser.esm.js + 3 modules
var index_browser_esm = __webpack_require__(27632);
// EXTERNAL MODULE: ./node_modules/decimal.js/decimal.mjs
var decimal = __webpack_require__(90482);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/components/base/Button/index.tsx
var Button = __webpack_require__(10737);
// EXTERNAL MODULE: ./src/hooks/use-amplitude.ts + 61 modules
var use_amplitude = __webpack_require__(54341);
// EXTERNAL MODULE: ./src/hooks/use-settings.ts + 1 modules
var use_settings = __webpack_require__(49472);
// EXTERNAL MODULE: ./src/hooks/use-tokens/index.ts + 1 modules
var use_tokens = __webpack_require__(28309);
// EXTERNAL MODULE: ./src/providers/nemo-program/index.tsx
var nemo_program = __webpack_require__(67477);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(73680);
// EXTERNAL MODULE: ./src/utils/numeric.ts
var numeric = __webpack_require__(14847);
;// CONCATENATED MODULE: ./src/components/liquidity-pools/helpers.ts

const DAY_IN_SECONDS = 60 * 60 * 24;
const calculatePoolApr = (param)=>{
    let { fee24h , totalLiquidity , reward24h , rateData , rewardTokenInfo  } = param;
    if (!totalLiquidity) return new decimal/* default */.Z(0);
    const tokenSymbol = rewardTokenInfo === null || rewardTokenInfo === void 0 ? void 0 : rewardTokenInfo.symbol.toUpperCase();
    const tokenRate = (rateData === null || rateData === void 0 ? void 0 : rateData[tokenSymbol]) || 0;
    const reward24hInUsd = (reward24h === null || reward24h === void 0 ? void 0 : reward24h.mul(tokenRate)) || new decimal/* default */.Z(0);
    // ((24h reward + 24h fee) / total liquidity) * 365
    return reward24hInUsd.plus(fee24h).div(totalLiquidity).mul(365).mul(100);
};

;// CONCATENATED MODULE: ./src/components/liquidity-pools/pool.tsx



























const PoolItem = (param)=>{
    let { pool  } = param;
    const amplitude = (0,use_amplitude/* default */.Z)();
    const trans = (0,useTrans/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { data: rateData  } = (0,use_settings/* useRemitanoRate */.T)();
    const theme = (0,useTheme/* default */.Z)();
    const { getTokenInfo  } = (0,use_tokens/* default */.Co)();
    const sm = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    const { client: nemoProgramClient  } = (0,nemo_program/* useNemoProgram */.J)();
    const poolAddress = pool.pool_address;
    const { data: whirlPool , isLoading: isLoadingWhirlPool  } = (0,es.useQuery)({
        queryKey: [
            "getPool",
            poolAddress
        ],
        queryFn: async ()=>{
            const poolKey = new index_browser_esm.PublicKey(poolAddress);
            const [, whirlPoolData] = await (0,helpers/* toResultAsync */.zM)(nemoProgramClient.getPool(poolKey));
            return whirlPoolData;
        }
    });
    const poolRewardInfo = (0,react.useMemo)(()=>{
        var _whirlPool_getRewardInfos;
        return (_whirlPool_getRewardInfos = whirlPool === null || whirlPool === void 0 ? void 0 : whirlPool.getRewardInfos()) === null || _whirlPool_getRewardInfos === void 0 ? void 0 : _whirlPool_getRewardInfos.find((rewardInfo)=>rewardInfo.initialized);
    }, [
        whirlPool
    ]);
    const poolRewardTokenInfo = (0,react.useMemo)(()=>{
        if (!poolRewardInfo) return null;
        return getTokenInfo(poolRewardInfo === null || poolRewardInfo === void 0 ? void 0 : poolRewardInfo.mint.toBase58());
    }, [
        poolRewardInfo,
        getTokenInfo
    ]);
    const emissionPerDay = (0,react.useMemo)(()=>{
        if (!poolRewardInfo || !poolRewardTokenInfo) return null;
        return dist.DecimalUtil.fromU64(/** Ref: https://github.com/renec-chain/nemo-swap/blob/master/scripts/create_pool/10_set_pool_reward_emission.ts#L97C75-L97C75 */ poolRewardInfo.emissionsPerSecondX64.muln(DAY_IN_SECONDS).shrn(64), poolRewardTokenInfo.decimals);
    }, [
        poolRewardInfo,
        poolRewardTokenInfo
    ]);
    const emissionPerDayStr = (0,react.useMemo)(()=>{
        return emissionPerDay ? (0,numeric/* format */.WU)(emissionPerDay) : "0";
    }, [
        emissionPerDay
    ]);
    const fee24h = (0,react.useMemo)(()=>{
        return new decimal/* default */.Z(pool.fee || 0).div(100).mul(pool.volumes_in_24h || 0);
    }, [
        pool
    ]);
    const aprValue = (0,react.useMemo)(()=>{
        return (0,numeric/* format */.WU)(calculatePoolApr({
            fee24h,
            totalLiquidity: Number(pool.total_liquidity),
            reward24h: emissionPerDay,
            rateData,
            rewardTokenInfo: poolRewardTokenInfo
        }).toFixed(2), {
            decimals: 2
        });
    }, [
        fee24h,
        pool.total_liquidity,
        emissionPerDay,
        rateData,
        poolRewardTokenInfo
    ]);
    const elmTokenPair = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        className: "py-4 px-6 bg-[#1A2332] rounded-t-[16px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        "data-testid": "img-token-a",
                        src: pool.token_a_logo_url || helpers/* NOT_AVAILABLE_LOGO_URL */.Ov,
                        alt: pool.token_a_name,
                        className: "rounded-full w-[40px] h-[40px] min-w-[40px] min-h-[40px] object-cover"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        "data-testid": "img-token-b",
                        src: pool.token_b_logo_url || helpers/* NOT_AVAILABLE_LOGO_URL */.Ov,
                        alt: pool.token_b_name,
                        className: "relative left-[-8px] w-[40px] h-[40px] min-w-[40px] min-h-[40px] rounded-full object-cover"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                "data-testid": "txt-pool-pair-name",
                className: "text-[20px] font-semibold text-[#C2CBD9]",
                children: [
                    pool.token_a_symbol,
                    " / ",
                    pool.token_b_symbol
                ]
            })
        ]
    });
    const elmFee = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        className: "text-xl font-bold text-white",
        children: [
            (0,numeric/* format */.WU)(pool.fee),
            "%"
        ]
    });
    const elmApr = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        className: "text-xl font-bold text-white",
        "data-testid": "apr-value",
        children: [
            aprValue,
            "%"
        ]
    });
    const elm24hVolume = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        className: "text-sm text-[#DDE0E5]",
        children: [
            "$",
            (0,numeric/* format */.WU)(pool.volumes_in_24h, 6)
        ]
    });
    const elm24hFee = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        className: "text-sm text-[#DDE0E5]",
        children: [
            "$",
            (0,numeric/* format */.WU)(fee24h.toFixed(6))
        ]
    });
    const elmTotalLiquidity = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        className: "text-sm text-[#DDE0E5]",
        children: [
            "$",
            (0,numeric/* format */.WU)(pool.total_liquidity || 0, 3)
        ]
    });
    const elmDepositButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        "data-testid": "btn-goto-open-position",
        className: "w-full",
        size: "md",
        onClick: ()=>{
            amplitude.track(use_amplitude/* EVENT_NAMES.liquidity_list_select */.K.liquidity_list_select, {
                from_token: pool.token_a_symbol,
                to_token: pool.token_b_symbol,
                pool_address: poolAddress
            });
            router.push("/liquidity/open-position/".concat(poolAddress));
        },
        children: trans.liquidity.pool.deposit
    });
    const elmRewardInfo = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        className: "text-center text-sm text-[#C2CBD9]",
        "data-testid": "reward-info",
        children: [
            trans.liquidity.pool.reward,
            ":",
            " ",
            emissionPerDayStr !== "0" && poolRewardTokenInfo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-base font-bold leading-none text-[#10DC60]",
                        children: [
                            "+",
                            emissionPerDayStr
                        ]
                    }),
                    " ",
                    poolRewardTokenInfo.displaySymbol,
                    "/",
                    trans.liquidity.pool.day
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-base font-bold leading-none text-[#9CA3AE]",
                children: "0"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        "data-testid": "pool-".concat(poolAddress),
        xs: md ? 4 : sm ? 6 : 12,
        children: [
            elmTokenPair,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "bg-[#1E2735] p-6 rounded-b-[16px] gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                flex: "1",
                                direction: "row",
                                alignItems: "center",
                                gap: "12px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            "data-testid": "table-heading-pool-fee",
                                            className: "text-sm text-[#9CA3AE]",
                                            children: trans.home.commission
                                        }),
                                        elmFee
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                flex: "1",
                                direction: "row",
                                alignItems: "center",
                                gap: "12px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            "data-testid": "table-heading-pool-fee",
                                            className: "text-sm text-[#9CA3AE]",
                                            children: "APR"
                                        }),
                                        elmApr
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: "py-4 border-t border-b border-solid border-[#3B4A5E]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                            size: "small",
                            padding: "none",
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-1.5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    "data-testid": "table-heading-pool-24h-volume-".concat(poolAddress),
                                                    sx: {
                                                        fontSize: 14,
                                                        color: "#888C9E"
                                                    },
                                                    children: trans.liquidity.pool.volume_24h
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-1.5 pl-2 text-right",
                                                children: elm24hVolume
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-1.5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    "data-testid": "table-heading-pool-24h-fee-".concat(poolAddress),
                                                    sx: {
                                                        fontSize: 14,
                                                        color: "#888C9E"
                                                    },
                                                    children: trans.liquidity.pool.fee_24h
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-1.5 pl-2 text-right",
                                                children: elm24hFee
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-1.5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    "data-testid": "table-heading-pool-liquidity",
                                                    sx: {
                                                        fontSize: 14,
                                                        color: "#888C9E"
                                                    },
                                                    children: trans.liquidity.pool.total_liquidity
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-1.5 pl-2 text-right",
                                                children: elmTotalLiquidity
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        gap: "8px",
                        alignItems: "center",
                        children: [
                            isLoadingWhirlPool ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 16,
                                width: "70%",
                                className: "transform-none inline-block",
                                "data-testid": "skeleton-reward-info"
                            }) : elmRewardInfo,
                            elmDepositButton
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var liquidity_pools_pool = (PoolItem);

;// CONCATENATED MODULE: ./src/components/liquidity-pools/pool.skeleton.tsx













const PoolItemSkeleton = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    const theme = (0,useTheme/* default */.Z)();
    const sm = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: md ? 4 : sm ? 6 : 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                className: "py-4 px-6 bg-[#1A2332] rounded-t-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 40,
                                width: 40,
                                variant: "circular"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 40,
                                width: 40,
                                variant: "circular",
                                className: "relative left-[-8px]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        "data-testid": "txt-pool-pair-name",
                        className: "text-[20px] font-semibold text-[#C2CBD9]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            height: 30,
                            width: 140
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "bg-[#1E2735] p-6 rounded-b-[16px] gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                flex: "1",
                                direction: "row",
                                alignItems: "center",
                                gap: "12px",
                                children: [
                                    "\\",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                "data-testid": "table-heading-pool-fee",
                                                className: "text-sm text-[#9CA3AE]",
                                                children: trans.home.commission
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                height: 28,
                                                width: 55
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                flex: "1",
                                direction: "row",
                                alignItems: "center",
                                gap: "12px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            "data-testid": "table-heading-pool-fee",
                                            className: "text-sm text-[#9CA3AE]",
                                            children: "APR"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            height: 28,
                                            width: 55
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: "py-4 border-t border-b border-solid border-[#3B4A5E]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                            size: "small",
                            padding: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-1.5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    "data-testid": "table-heading-pool-24h-volume-?",
                                                    sx: {
                                                        fontSize: 14,
                                                        color: "#888C9E"
                                                    },
                                                    children: trans.liquidity.pool.volume_24h
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-1.5 pl-2 text-right",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    height: 20,
                                                    width: 50,
                                                    className: "inline-block transform-none"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-1.5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    "data-testid": "table-heading-pool-24h-fee-?",
                                                    sx: {
                                                        fontSize: 14,
                                                        color: "#888C9E"
                                                    },
                                                    children: trans.liquidity.pool.fee_24h
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-2 pl-2 text-right",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    height: 20,
                                                    width: 50,
                                                    className: "inline-block transform-none"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    "data-testid": "table-heading-pool-liquidity",
                                                    sx: {
                                                        fontSize: 14,
                                                        color: "#888C9E"
                                                    },
                                                    children: trans.liquidity.pool.total_liquidity
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: "border-none py-2 pl-2 text-right",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    height: 20,
                                                    width: 60,
                                                    className: "inline-block transform-none"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        gap: "8px",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 20,
                                width: "70%",
                                className: "transform-none"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 40,
                                width: "100%",
                                className: "transform-none"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const PoolSkeleton = (param)=>{
    let { numPools =0  } = param;
    const theme = (0,useTheme/* default */.Z)();
    const sm = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    // The number of pool item skeletons should fill the remaining blank space of
    // the last pool line, e.g., on large screens with three pools per line, two
    // skeletons should show in the position of the remaining pool items if there
    // is currently one pool alone on that line.
    // If the last pool line has no empty space left, show a new line with all
    // pool skeletons.
    const numPoolsPerLine = md ? 3 : sm ? 2 : 3;
    const numSkeletons = numPoolsPerLine - numPools % numPoolsPerLine;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: [
            ...Array(numSkeletons)
        ].map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PoolItemSkeleton, {}, index))
    });
};
/* harmony default export */ var pool_skeleton = (PoolSkeleton);

;// CONCATENATED MODULE: ./src/components/liquidity-pools/view.tsx











const View = (props)=>{
    var _poolsData_pages;
    const { poolsData , inputValue , setInputValue , isLoading , fetchNextPage , isEmptyPools  } = props;
    const trans = (0,useTrans/* default */.Z)();
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    (0,react.useEffect)(()=>{
        if (inView) {
            fetchNextPage();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: "mt-6 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* default */.Z, {
                inputValue: inputValue,
                setInputValue: setInputValue,
                tabActive: "pools",
                className: "mb-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                className: "h-full",
                justifyContent: "space-between",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: "w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            "data-testid": "container-pool-list",
                            className: "w-full",
                            children: [
                                !isLoading && isEmptyPools(poolsData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    className: "m-8",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        children: inputValue ? trans.liquidity.no_results_found : trans.liquidity.no_pools_found
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    spacing: !isEmptyPools(poolsData) || isLoading ? 2 : 0,
                                    children: [
                                        (poolsData === null || poolsData === void 0 ? void 0 : poolsData.pages) && (poolsData === null || poolsData === void 0 ? void 0 : (_poolsData_pages = poolsData.pages) === null || _poolsData_pages === void 0 ? void 0 : _poolsData_pages.length) > 0 && poolsData.pages.map((poolsData)=>poolsData.pools.map((pool)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(liquidity_pools_pool, {
                                                    pool: pool
                                                }, pool.pool_address))),
                                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(pool_skeleton, {
                                            numPools: poolsData === null || poolsData === void 0 ? void 0 : poolsData.pages.reduce((prev, curr)=>prev + curr.pools.length, 0)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                            ref: ref
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var view = (/*#__PURE__*/(0,react.memo)(View));

;// CONCATENATED MODULE: ./src/components/liquidity-pools/container.tsx





let debounceFn;
const Container = ()=>{
    const [inputValue, setInputValue] = (0,react.useState)("");
    const [keyword, setKeyword] = (0,react.useState)("");
    const { data: poolsFromBE , isFetching: isFetchingPools , fetchNextPage: fetchPoolsNextPage  } = (0,use_nemo_apis/* useLiquidityPoolsInfinite */.uf)(keyword);
    const fetch = (0,react.useMemo)(()=>debounceFn = (0,debounce/* default */.Z)((request)=>{
            setKeyword(request.input);
        }, 400), []);
    (0,react.useEffect)(()=>{
        if (debounceFn) {
            debounceFn.clear();
        }
        if (inputValue) {
            fetch({
                input: inputValue
            });
        } else {
            setKeyword("");
        }
    }, [
        inputValue,
        fetch
    ]);
    const fetchNextPage = (0,react.useCallback)(()=>{
        if (!(poolsFromBE === null || poolsFromBE === void 0 ? void 0 : poolsFromBE.pages[poolsFromBE.pageParams.length - 1].has_next_page)) return;
        fetchPoolsNextPage();
    }, [
        fetchPoolsNextPage,
        poolsFromBE === null || poolsFromBE === void 0 ? void 0 : poolsFromBE.pageParams.length,
        poolsFromBE === null || poolsFromBE === void 0 ? void 0 : poolsFromBE.pages
    ]);
    const isEmptyPools = (0,react.useCallback)((poolsData)=>{
        if (!poolsData) return true;
        if (poolsData.pages.length === 1 && poolsData.pages[0].pools.length === 0) return true;
        return false;
    }, []);
    const computedProps = {
        poolsData: poolsFromBE,
        inputValue,
        setInputValue,
        isLoading: isFetchingPools,
        fetchNextPage: fetchNextPage,
        isEmptyPools
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(view, {
        ...computedProps
    });
};
/* harmony default export */ var container = (Container);

;// CONCATENATED MODULE: ./src/components/liquidity-pools/index.tsx


// EXTERNAL MODULE: ./src/layouts/MainLayout/index.tsx + 24 modules
var MainLayout = __webpack_require__(33509);
;// CONCATENATED MODULE: ./src/pages/liquidity/browse.nemo.tsx



const LiquidityPoolsPage = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* MainLayout */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container, {})
    });
};
var __N_SSP = true;
/* harmony default export */ var browse_nemo = (LiquidityPoolsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,7357,6571,3419,3595,7375,1988,2833,9774,2888,179], function() { return __webpack_exec__(64049); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);